import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';

/**
 * Hook to connect to admin SSE endpoint and auto-invalidate queries
 * when new visits or user registrations happen.
 */
export function useAdminSSE() {
  const queryClient = useQueryClient();
  const eventSourceRef = useRef<EventSource | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    const url = `/api/v1/admin/events?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);
    eventSourceRef.current = es;

    es.addEventListener('new-visit', () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'visits'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'referral-funnel'] });
    });

    es.addEventListener('new-user', () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'referral-funnel'] });
    });

    es.onerror = () => {
      // EventSource auto-reconnects, no action needed
    };

    return () => {
      es.close();
      eventSourceRef.current = null;
    };
  }, [queryClient]);
}
